import { render, staticRenderFns } from "./asider-nigeria.vue?vue&type=template&id=4ef12346&scoped=true&"
import script from "./asider-nigeria.vue?vue&type=script&lang=js&"
export * from "./asider-nigeria.vue?vue&type=script&lang=js&"
import style0 from "./asider-nigeria.vue?vue&type=style&index=0&id=4ef12346&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef12346",
  null
  
)

export default component.exports